// extracted by mini-css-extract-plugin
module.exports = {"container":"_1xNRcQQu39XbrLMwBp5Mws","cancelBtn":"_2bgRYJ-BA6c12SIidS887W","icon":"_1BaeA0cFIqvrUgxzsQgDQ9","saveBtn":"_26MLTiKRAY5fglwN-nhIPR"};